import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row } from 'react-bootstrap';

import SelectDropDown from '../selectdropdown/SelectDropDown';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";

class EditEmployeeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    render() {

        console.log("this.props.stateData",this.props.stateData)
        let modulesSelectAll = true;
        let modulesLabelledBy = "Select";
        let modulesdisablesearch = false;
        if (this.props.stateData.collegeModulesOptions.length > 0) {
            modulesSelectAll = true;
            modulesdisablesearch = false;
        }
        else {
            modulesdisablesearch = true;
            modulesSelectAll = false;
            modulesLabelledBy = "Modules"
        }

        let subjectSelectAll = true;
        let subjectLabelledBy = "Select";
        let subjectdisablesearch = false;
        if (this.props.stateData.subjectOptions.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectLabelledBy = "Subjects"
        }

        return (
            <Modal {...this.props}
                size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Employee Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Employee User Name"
                                    name="user_name"
                                    onChange={this.props.handleInputChange}
                                    autoComplete="off"
                                    value={this.props.stateData.Username}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.usernameError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase">Employee Password<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Password"
                                    onChange={this.props.handleInputChange}
                                    autoComplete="new-password"
                                    name="password"
                                    value={this.props.stateData.password}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.passwordError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    onChange={this.props.handleInputChange}
                                    autoComplete="off"
                                    value={this.props.stateData.email}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.emailError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Contact No</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Mobile No"
                                    name="contact_no"
                                    onChange={this.props.handleInputChange}
                                    autoComplete="off"
                                    value={this.props.stateData.contact_no}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.contact_noError}
                                </Form.Text>
                            </Form.Group>

                            {
                                this.props.stateData.preSelectedsubjectValues[0] != "" ?
                                    (
                                        <Form.Group as={Col} xl={6} lg={6} md={6} sm={12} controlId="SelectSubject">
                                            <Form.Label className="text-uppercase">Select Subjects</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Subjects are selected.",
                                                    "selectSomeItems": subjectLabelledBy
                                                }
                                                }
                                                disableSearch={subjectdisablesearch}
                                                hasSelectAll={subjectSelectAll}
                                                options={this.props.stateData.subjectOptions}
                                                value={this.props.stateData.preSelectedSubjects}
                                                onChange={(e) => this.props.handleMultipleSelectInputChange(e, "subjects")}
                                                labelledBy={"Subjects"}
                                            />
                                            <Form.Text className="form-text text-danger">
                                                {this.props.stateData.selectedsubjectsError}
                                            </Form.Text>
                                        </Form.Group>
                                    )
                                    :
                                    ("")
                            }

                            <Form.Group as={Col} xl={6} lg={6} md={6} sm={12} controlId="SelectSubject">
                                <Form.Label className="text-uppercase">Select College Modules</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Modules are selected.",
                                        "selectSomeItems": modulesLabelledBy
                                    }
                                    }
                                    disableSearch={modulesdisablesearch}
                                    hasSelectAll={modulesSelectAll}
                                    options={this.props.stateData.collegeModulesOptions}
                                    value={this.props.stateData.prefilledModules}
                                    onChange={(e) => this.props.handleMultipleSelectInputChange(e, "modules")}
                                    labelledBy={"Modules"}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.selectedModulesArrayError}
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer variant="white" className="px-4">
                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <Button onClick={this.props.handleFormSubmit} className="btn btn-success text-uppercase" >
                                {
                                    this.props.stateData.loadingSpinner == 1 ?
                                        (<div class="spinner-border text-light  loading-img-center mr-2" style={{ width: "1rem", height: "1rem" }}></div>)
                                        :
                                        ("")
                                }
                                Save
                            </Button>
                        </Col>
                        {this.props.stateData.currentStep == 5 ? (
                            <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                Data Saved successfully
                            </Form.Text>
                        ) : (
                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                {this.props.stateData.submitError}
                            </Form.Text>
                        )}
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default

    (EditEmployeeModal);